const hoverable_icons = [
    {name: 'beetroot', header: 'Beetroot', text: ''},
    {name: 'coconut', header: 'Coconut water', text: ''},
  	{name: 'yerbamate', header: 'Yerba Mate', text: ''},
  {name: 'ginger', header: 'Ginger', text: ''},
    {name: 'cranberries', header: 'Cranberries', text: ''},
    {name: 'lemon', header: 'Lemon', text: ''},
    {name: 'Orange', header: 'Orange', text: ''},
    {name: 'pineapple', header: 'Pineapple', text: ''},
    {name: 'turmeric', header: 'Turmeric', text: ''}
  ]